import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface SleepTimeDialogProps extends HelpDialogLayoutProps {}
export default function SleepTimeDialog(props: SleepTimeDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            適切な睡眠時間について
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "適切な睡眠時間は個人差がありますが、18～64歳では7～9時間が推奨されています。「7～9時間」と聞くと長く感じるかもしれませんが、日本人の睡眠時間は諸外国と比べて短い傾向にあります。2020年の国民生活時間調査によると、日本人の平均睡眠時間は7時間22分で、OECD加盟国の平均である8時間28分より1時間以上短い結果となっています。",
              ]}
            />
          </ContentStack>
        </SectionStack>

        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            睡眠時間と健康リスクの関係
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "個人差があるため、適切な睡眠時間は日中に眠気を感じない程度とされていますが、眠気に関わらず、睡眠時間が短すぎると将来的に病気のリスクが高まることが多くの研究で報告されています。例えば、睡眠時間が7時間前後の人は、肥満、糖尿病、高血圧などの病気になるリスクが最も低いとされています。",
              ]}
            />
          </ContentStack>
        </SectionStack>

        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            理想的な睡眠時間の確保
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "理想としては毎日7時間以上の睡眠を確保することが望ましいですが、忙しい日でも最低6時間の睡眠を取るよう心がけましょう。",
              ]}
            />
          </ContentStack>
        </SectionStack>

        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            65歳以上の睡眠時間
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "65歳以上では、推奨される睡眠時間は7～8時間です。加齢とともに自然に睡眠時間が短くなるのは正常な現象です。そのため、6時間程度でも十分とされています。むしろ、長時間寝ようとしすぎて寝床の上で過ごす時間が長くなることが問題となる場合があるので、眠れないと感じたら、逆に遅寝・早起きにして睡眠時間を少し短くすると、睡眠の質が高まり熟睡感を得られるようになる場合があります。また、日中に外出したり人に会ったりとメリハリのある生活を意識すると、寝付きの改善や睡眠の質が向上することが報告されています。",
              ]}
            />
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
